import React from 'react';

const LocationPin = () => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1096_12878)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.55101 5.62223C5.40071 5.62511 5.25134 5.598 5.11164 5.54248C4.97194 5.48695 4.84471 5.40413 4.7374 5.29886C4.63009 5.19358 4.54484 5.06797 4.48664 4.92936C4.42845 4.79075 4.39848 4.64193 4.39848 4.4916C4.39848 4.34127 4.42845 4.19245 4.48664 4.05384C4.54484 3.91523 4.63009 3.78962 4.7374 3.68434C4.84471 3.57907 4.97194 3.49625 5.11164 3.44073C5.25134 3.3852 5.40071 3.35809 5.55101 3.36098C5.84712 3.36666 6.12917 3.48828 6.33657 3.69969C6.54396 3.91111 6.66014 4.19544 6.66014 4.4916C6.66014 4.78776 6.54396 5.07209 6.33657 5.28351C6.12917 5.49492 5.84712 5.61654 5.55101 5.62223ZM4.66601 0.745142C2.88685 1.14223 1.63935 2.81681 1.70935 4.63848C1.76435 6.06931 2.64226 7.34931 5.25435 9.86056C5.41935 10.0189 5.68351 10.0197 5.84893 9.86098C8.5506 7.26389 9.39726 5.98389 9.39726 4.49139C9.39726 2.07889 7.17518 0.185142 4.66601 0.745559"
          fill="#8E99A6"
        />
      </g>
      <defs>
        <clipPath id="clip0_1096_12878">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(0.551025 0.3125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LocationPin;
